import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import useAutoFocus from 'src/hooks/useAutoFocus';
import useConfirm from 'src/hooks/useConfirm';
import Button from './design-system/Button';
import Dialog from './design-system/Dialog';

const ConfirmDialog = () => {
  const { dialogSettings, open, onCancel, onConfirm } = useConfirm();

  const confirmButtonRef = useAutoFocus(!!open, [dialogSettings]);

  return (
    <Dialog
      width={dialogSettings?.width}
      height={dialogSettings?.height}
      open={!!open}
      onClose={dialogSettings?.onClose || onCancel}
      title={dialogSettings?.title || ''}
      className={dialogSettings?.className}
      closeIcon={dialogSettings?.closeIcon}
      id={dialogSettings?.id ?? 'modal'}
    >
      {dialogSettings?.content}
      <DialogActionsBar>
        <div className={dialogSettings?.actionBarStyles || 'flex justify-end gap-2'}>
          {!dialogSettings?.hasNoConfirmButton && (
            <Button
              color={dialogSettings?.confirmColor}
              ref={confirmButtonRef}
              onClick={onConfirm}
              disabled={dialogSettings?.confirmDisabled}
            >
              {dialogSettings?.confirmButtonText}
            </Button>
          )}
          {!dialogSettings?.hasNoCancelButton && (
            <Button color={dialogSettings?.cancelColor} onClick={onCancel}>
              {dialogSettings?.cancelButtonText}
            </Button>
          )}
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default ConfirmDialog;
